import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ImasterContent } from "../interfaces/imaster-content";
import { IResponseService } from "../interfaces/response-service";
import { BaseService } from "./base.service";


@Injectable()
export class FormService extends BaseService {


  constructor(public http: HttpClient) {
    super(http);
  }


  /**
   * @author Jose Wilson Mulato
   * @description obtiene el contenido del servicio para retornarlo a las class store que lo usen
   * @param response
   */
  GetResponseDataService(response: IResponseService): ImasterContent[] {
    return response && response.data ? (response.data as ImasterContent[]) : [];
  }

  /**
    * @author Jose Wilson Mulato
    * @description Obtiene datos de asociado cooperativa si lo es
    * @param idPlace
    */
  async GetDatosAsociadoCoop(tipIdentificacion: number, numIdentificacion: number) {
    let response: any = await super.Get(`getDatosAsociado/${tipIdentificacion}/${numIdentificacion}`, {});
    return this.GetResponseDataService(response);
  }


  public getIPAddress() {
    return this.http.get("http://api.ipify.org/?format=json");
  }


  /**
    * @author Jose Wilson Mulato
    * @description Obtiene datos de saldo pinos
    * @param idPlace
    */
  async getSaldoPinos(tipIdentificacion: string, numIdentificacion: string) {
    let response: any = await super.Get(`consultarSaldoPinos/${tipIdentificacion}/${numIdentificacion}`, {});
    return this.GetResponseDataService(response);
  }


  /**
    * @author Jose Wilson Mulato
    * @description Obtiene parametros
    * @param idPlace
    */
  async getParametros() {
    let response: any = await super.Get(`consultarParametros`, {});
    return response;
  }

  /**
    * @author Andres lopez
    * @description Obtiene matriculas inscritas del asociado
    * @param idPlace
    */
   async getCuentaMatricula(numIdentificacion: string) {
    let response: any = await super.Get(`consultarMatriculas/${numIdentificacion}`, {});
    return response;
  }


  /**
    * @author Jose Wilson Mulato
    * @description Obtiene datos si ya dono por pesos
    * @param idPlace
    */
   async consultarDonacionesPesos(numIdentificacion: string) {
    let response: any = await super.Get(`consultarDonacionesPesos/${numIdentificacion}`, {});
    return this.GetResponseDataService(response);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/form.service.ts